import { render, staticRenderFns } from "./BaseSelectObject.vue?vue&type=template&id=013b82c6&"
import script from "./BaseSelectObject.vue?vue&type=script&lang=js&"
export * from "./BaseSelectObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports